// extracted by mini-css-extract-plugin
module.exports = {"socialsWrap":"Socials_socialsWrap__1w0GQ","socialsList":"Socials_socialsList__2sWvZ","imgLink":"Socials_imgLink__1k0d5","img":"Socials_img__3PcFF"};